import React, { useRef, useState } from 'react';

import { IconButton, Icons } from '@components/common';
import { ELinkMenuPlacement } from '@components/routes/AdminPanel/ManageCrowdCells/LinkMenu/enum';
import ActionMenu from '@components/routes/AdminPanel/ManageCrowdCells/LinkMenu/LinkActionList';

import { useOnClickOutsideSelect } from '@hooks/utils/useOnClickOutSide';

import { ILinkActionInterface } from '@components/routes/AdminPanel/ManageCrowdCells/interfaces';

import styles from './SaveButton.module.scss';

interface SaveButtonProps {
	isDisabled: boolean;
	actions: Array<ILinkActionInterface>;
	savePreset: () => void;
}

const SaveButton = ({
	isDisabled,
	actions,
	savePreset,
}: SaveButtonProps) => {
	const menuRef = useRef<HTMLDivElement | null>(null);
	const buttonRef = useRef<HTMLDivElement | null>(null);

	const isEditPresetAccess = actions.length > 1;

	const tooltipLabel = isEditPresetAccess ? undefined : 'Save as preset';

	const [showMenu, setShowMenu] = useState(false);

	const onClickSaveButton = () => isEditPresetAccess ? setShowMenu((prev) => !prev) : savePreset();

	const closeShowMenu = () => setShowMenu(false);

	useOnClickOutsideSelect([buttonRef, menuRef], () => showMenu && isEditPresetAccess && closeShowMenu());

	return (
		<div
			ref={buttonRef}
			className={styles.saveButtonWrapper}
		>
			{showMenu && isEditPresetAccess && (
				<ActionMenu
					actions={actions}
					menuPlacement={ELinkMenuPlacement.top}
					menuRef={menuRef}
					selectHandler={closeShowMenu}
				/>
			)}
			<IconButton
				icon={Icons.saveIcon}
				isDisabled={isDisabled}
				onClick={onClickSaveButton}
				tooltipLabel={tooltipLabel}
			/>
		</div>
	);
};

export default SaveButton;
